import Vue from 'vue'
import Router from 'vue-router'
import store from '@/vuex/store'

// Containers
import containers from '@/components/containers'

// Pages
import auth from '@/components/pages/auth'
import Dashboard from '@/components/pages/Dashboard'
import Settings from '@/components/pages/Settings'
import Profile from '@/components/pages/Profile'
import Page404 from '@/components/pages/404'

// Manageables?
import ManageableHandler from '@/components/pages/manageables/Handler'
import ManageableIndex from '@/components/pages/manageables/Index'
import ManageableCreate from '@/components/pages/manageables/Create'
import ManageableEdit from '@/components/pages/manageables/Edit'

Vue.use(Router)

const router = new Router({
  // mode: 'history',
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'auth',
      redirect: { name: 'auth.login' },
      component: containers.ContainerFull,
      meta: { auth: false },
      children: [
        {
          path: 'login',
          name: 'auth.login',
          component: auth.Login
        },
        {
          path: 'forgot-password',
          name: 'auth.forgot-password',
          component: auth.ForgotPassword
        },
        {
          path: 'change-password',
          name: 'auth.change-password',
          component: auth.ChangePassword
        }
      ]
    },
    {
      path: '/',
      redirect: { name: 'app.dashboard' },
      name: 'index',
      component: containers.ContainerDefault,
      meta: {
        label: 'Dashboard',
        auth: true,
        entity: false
      },
      children: [{
        path: '',
        name: 'app.dashboard',
        component: Dashboard,
        meta: {
          label: 'Dashboard',
          entity: false
        }
      },
      {
        path: 'settings',
        name: 'app.settings',
        component: Settings,
        meta: {
          back: { name: 'app.dashboard' },
          label: 'Configurações',
          entity: false
        }
      },
      {
        path: 'profile',
        name: 'app.profile',
        component: Profile,
        meta: {
          back: { name: 'app.dashboard' },
          label: 'Perfil',
          entity: false
        }
      },
      {
        path: 'vmz-tickets-disney-date-basic',
        name: 'app.vmz-tickets-disney-date-basic',
        redirect: {
          path: '/vmz-tickets-disney-date-basic/1',
          query: { date_mode: 'specific_date', type: 'basic' }
        },
        component: ManageableHandler,
        meta: {
          back: { name: 'app.dashboard' },
          label: 'Tickets Disney (com data) - Básico',
          entity: false
        }
      },
      {
        path: 'vmz-tickets-disney-date-hopper',
        name: 'app.vmz-tickets-disney-date-hopper',
        redirect: {
          path: '/vmz-tickets-disney-date-hopper/3',
          query: { date_mode: 'specific_date', type: 'hopper' }
        },
        component: ManageableHandler,
        meta: {
          back: { name: 'app.dashboard' },
          label: 'Tickets Disney (com data) - Hopper',
          entity: false
        }
      },
      {
        path: 'vmz-tickets-disney-date-hopper-plus',
        name: 'app.vmz-tickets-disney-date-hopper-plus',
        redirect: {
          path: '/vmz-tickets-disney-date-hopper-plus/5',
          query: { date_mode: 'specific_date', type: 'hopper-plus' }
        },
        component: ManageableHandler,
        meta: {
          back: { name: 'app.dashboard' },
          label: 'Tickets Disney (com data) - Hopper Plus',
          entity: false
        }
      },
      {
        path: 'vmz-tickets-disney-flex-basic',
        name: 'app.vmz-tickets-disney-flex-basic',
        redirect: {
          path: '/vmz-tickets-disney-flex-basic/2',
          query: { date_mode: 'flex', type: 'basic' }
        },
        component: ManageableHandler,
        meta: {
          back: { name: 'app.dashboard' },
          label: 'Tickets Disney (flex) - Básico',
          entity: false
        }
      },
      {
        path: 'vmz-tickets-disney-flex-hopper',
        name: 'app.vmz-tickets-disney-flex-hopper',
        redirect: {
          path: '/vmz-tickets-disney-flex-hopper/4',
          query: { date_mode: 'flex', type: 'hopper' }
        },
        component: ManageableHandler,
        meta: {
          back: { name: 'app.dashboard' },
          label: 'Tickets Disney (flex) - Hopper',
          entity: false
        }
      },
      {
        path: 'vmz-tickets-disney-flex-hopper-plus',
        name: 'app.vmz-tickets-disney-flex-hopper-plus',
        redirect: {
          path: '/vmz-tickets-disney-flex-hopper-plus/6',
          query: { date_mode: 'flex', type: 'hopper-plus' }
        },
        component: ManageableHandler,
        meta: {
          back: { name: 'app.dashboard' },
          label: 'Tickets Disney (flex) - Hopper Plus',
          entity: false
        }
      },
      {
        path: 'rte-customers',
        name: 'app.rte-customers',
        redirect: {
          path: '/rte-customer/new'
        },
        component: ManageableHandler,
        meta: {
          back: { name: 'app.dashboard' },
          label: 'Clientes',
          entity: false
        }
      },
      // Generic Manageable Operations
      {
        path: ':entity([\\a-zA-Z-]+)',
        name: 'entity.handler',
        redirect: { name: 'manageables.index' },
        component: ManageableHandler,
        meta: {
          entity: true
        },
        children: [
          {
            path: '',
            name: 'manageables.index',
            component: ManageableIndex,
            meta: {
              back: { name: 'app.dashboard' },
              label: 'Listagem'
            }
          },
          {
            path: 'new',
            name: 'manageables.create',
            component: ManageableCreate,
            meta: {
              back: { name: 'manageables.index' },
              label: 'Criar'
            }
          },
          {
            path: ':id([0-9+]+)',
            name: 'manageables.edit',
            component: ManageableEdit,
            meta: {
              back: { name: 'manageables.index' },
              label: 'Editar'
            }
          }
        ]
      },
      // Generic nested entity resolver
      {
        path: ':entity([\\a-zA-Z-]+)/:id([0-9+]+)/:nestedEntity([\\a-zA-Z-]+)',
        name: 'entity.handler',
        redirect: { name: 'manageables.edit' },
        component: ManageableHandler,
        meta: {
          entity: true
        },
        children: [
          {
            path: 'new',
            name: 'manageables.nested.create',
            component: ManageableCreate,
            meta: {
              nested: true,
              back: { name: 'manageables.edit' },
              label: 'Criar'
            }
          },
          {
            path: ':nestedId([0-9+]+)',
            name: 'manageables.nested.edit',
            component: ManageableEdit,
            meta: {
              nested: true,
              back: { name: 'manageables.edit' },
              label: 'Editar'
            }
          }
        ]
      }
      ]
    },
    {
      path: '404',
      name: '404',
      component: Page404
    },
    {
      path: '*',
      redirect: { name: 'index' }
    }
  ]
})

// Guard on route change
router.beforeEach((to, from, next) => {
  store.dispatch('errors/clearError', ['UnprocessableEntity'])

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js